<div class="blocks-container">
  <h3>Bloqueos</h3>
  <p>Configuración de bloqueos temporales de disponibilidad.</p>
  <p>Location ID: {{ locationId }}</p>
</div>
